module.exports = __webpack_public_path__ + "img/empty.c402d527.png";